import React from 'react';
import Root from './root';

const Route: React.FC = () => {
    return <Root />;
};

export default Route;
